/**
 * ATELIER LUXURY SHOPIFY THEME - RECENTLY VIEWED PRODUCTS
 */

document.addEventListener('DOMContentLoaded', () => {
  const currentProduct = document.querySelector('[data-product-id]');
  const STORAGE_KEY = 'atelier_recently_viewed';

  if (document.body.classList.contains('template-product') && currentProduct) {
    const productId = currentProduct.dataset.productId;
    if (productId) {
      let viewed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      viewed = viewed.filter((id) => id !== productId);
      viewed.unshift(productId);
      if (viewed.length > 8) viewed.pop();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed));
    }
  }

  // Populate Recently Viewed section if present
  const recentlyViewedSection = document.querySelector('[data-recently-viewed-section]');
  if (recentlyViewedSection) {
    const currentId = currentProduct?.dataset?.productId;
    let viewed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    viewed = viewed.filter((id) => id !== currentId);

    if (viewed.length === 0) {
      recentlyViewedSection.hidden = true;
      return;
    }

    // Fetch products
    const query = viewed.slice(0, 4).map((id) => `id:${id}`).join(' OR ');
    fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`)
      .then((res) => res.json())
      .then((data) => {
        const products = data?.resources?.results?.products || [];
        const grid = recentlyViewedSection.querySelector('[data-recently-viewed-grid]');
        if (products.length > 0 && grid) {
          recentlyViewedSection.hidden = false;
          grid.innerHTML = products.map((p) => `
            <div class="product-card">
              <div class="product-card__media-wrapper aspect-ratio-portrait" style="--aspect-ratio: 0.75;">
                <a href="${p.url}" class="product-card__media-link">
                  <div class="product-card__media">
                    <img src="${p.featured_image.url}" alt="${p.title}" class="product-card__image" loading="lazy" width="400" height="533">
                  </div>
                </a>
              </div>
              <div class="product-card__content">
                <h3 class="product-card__title">
                  <a href="${p.url}">${p.title}</a>
                </h3>
                <div class="price-container">
                  <span class="price-item price-item--regular">${window.formatMoney(p.price)}</span>
                </div>
              </div>
            </div>
          `).join('');
        } else {
          recentlyViewedSection.hidden = true;
        }
      })
      .catch(() => {
        recentlyViewedSection.hidden = true;
      });
  }
});
